<template>
    <div class="">
        <!-- DataTable Component -->
        <DataTable
            :perPage="itemsPerPage"
            :columns="visibleColumns"
            :items="tableData"
            :currentPage="currentPage"
            :totalPages="totalPages"
            :selectedItems="selectedItems"
            :enableDragDrop="false"
            :enableMultiSelect="false"
            rowClass="text-center"
            :sortBy="sortColumn"
            :sortOrder="sortDirection"
            :showColumns="false"
            @page-changed="handlePageChange"
            @item-selected="toggleItemSelection"
            @select-all-toggled="toggleSelectAll"
            @sort="handleSort"
        >
            <!-- Toolbar Slot -->
            <template #toolbar>
                <div class="ppv2-flex ppv2-flex-wrap ppv2-items-center" :style="{ gap: normalizeSize(16, true) }">
                    <!-- Search Input -->
                    <div class="ppv2-relative">
                        <Search v-if="searchView" v-model="search" :emitGlobal="false" @search-updated="handleSearchUpdate" />
                    </div>

                    <!-- Status Filter (Archived vs Active) -->
                    <!-- <div class="ppv2-relative">
                        <select v-model="statusFilter" @change="handleStatusChange"
                            class="ppv2-bg-white ppv2-border ppv2-border-solid ppv2-border-black ppv2-rounded-xl ppv2-px-4 ppv2-py-2 ppv2-text-sm poppinsRegular ppv2-text-black focus:ppv2-outline-none focus:ppv2-ring-2 focus:ppv2-ring-[#7D2DBD] ppv2-min-h-[40px]">
                            <option value="">{{ $t('treatment_customer.all_active') }}</option>
                            <option value="archived">{{ $t('treatment_customer.archived') }}</option>
                        </select>
                    </div> -->

                    <!-- Export Button -->
                    <ExportSelect
                        v-if="exportView"
                        :label="$t('treatment_customer.export')"
                        :options="[
                            { label: $t('treatment_customer.csv'), value: 'csv' },
                            { label: $t('treatment_customer.excel'), value: 'excel' },
                        ]"
                        :disabled="exportLoading"
                        :loading="exportLoading"
                        @export-selected="downloadTreatments"
                    />

                    <div class="ppv2-flex-1"></div>
                    <!-- Column Visibility Toggle -->
                    <!--<div class="ppv2-relative" ref="columnsDropdown">
                        <button
                            @click="showColumns = !showColumns"
                            class="filterButton ppv2-flex ppv2-items-center ppv2-gap-3 ppv2-px-4 ppv2-py-2 ppv2-rounded-xl ppv2-border ppv2-border-solid ppv2-border-black ppv2-border-opacity-20 ppv2-text-black hover:ppv2-bg-opacity-80 ppv2-transition-all"
                        >
                            <FilePen class="ppv2-w-5 ppv2-h-5" />
                            <span class="poppinsLight" :style="{ fontSize: normalizeFontSize(15) }">
                                {{ $t('customers.columns') }}
                            </span>
                            <ChevronDown class="ppv2-w-4 ppv2-h-4" />
                        </button>
                        <div
                            v-if="showColumns"
                            class="menuDropdown ppv2-absolute ppv2-top-full ppv2-right-0 ppv2-mt-2 ppv2-rounded-md ppv2-overflow-hidden ppv2-z-50"
                        >
                            <div class="ppv2-max-h-[300px] ppv2-overflow-y-auto">
                                <label
                                    v-for="(column, index) in allColumns"
                                    :key="index"
                                    class="dropdownItem ppv2-flex ppv2-items-center ppv2-gap-3 ppv2-px-4 ppv2-py-1 ppv2-cursor-pointer ppv2-transition-colors"
                                >
                                    <BaseCheckbox
                                        :value="selectedColumnKeys.includes(column.key)"
                                        @input="toggleColumn(column.key)"
                                        size="sm"
                                        :hasBorderChecked="true"
                                    />
                                    <span class="poppinsLight" :style="{ fontSize: normalizeFontSize(14) }">{{
                                        column.label
                                    }}</span>
                                </label>
                            </div>
                        </div>
                    </div>-->
                </div>
            </template>

            <!-- Column: Treatment Name -->
            <template #column-name="{ item }">
                <span class="ppv2-text-gray poppinsRegular" :style="{ fontSize: normalizeFontSize(14) }">
                    {{ item.name }}
                </span>
            </template>

            <template #column-created_at="{ item }">
                <span class="ppv2-text-gray poppinsRegular" :style="{ fontSize: normalizeFontSize(14) }">
                    {{ item.created_at }}
                </span>
            </template>

            <!-- Column: Quantity Remaining -->
            <template #column-qte_rest="{ item }">
                <span class="ppv2-text-gray poppinsRegular" :style="{ fontSize: normalizeFontSize(14) }">
                    {{ item.qte_rest }}
                </span>
            </template>

            <!-- Column: Expiration Date -->
            <template #column-expire_at="{ item }">
                <span class="ppv2-text-gray poppinsRegular" :style="{ fontSize: normalizeFontSize(14) }">
                    {{ item.expire_at }}
                </span>
            </template>

            <template #column-type="{ item }">
                <span
                    class="ppv2-text-gray poppinsRegular"
                    :style="{
                        fontSize: normalizeFontSize(14),
                    }"
                >
                    {{ $t(`customerInfo.types.${item.type}`) }}
                </span>
            </template>

            <template #column-actions="{ item }">
                <div class="ppv2-flex ppv2-items-center ppv2-justify-center">
                    <v-menu offset-y left transition="slide-y-transition">
                        <template v-slot:activator="{ on, attrs }">
                            <button
                                v-on="on"
                                v-bind="attrs"
                                class="ppv2-p-1 ppv2-text-black hover:ppv2-bg-black hover:ppv2-bg-opacity-10 ppv2-rounded ppv2-transition-all"
                            >
                                <MoreVertical :size="18" />
                            </button>
                        </template>
                        <v-list class="actionsDropdown !ppv2-p-0">
                            <!-- Modifier (Link to V2 Edit Page) -->
                            <v-list-item class="!ppv2-p-0">
                                <a
                                    :href="`/back-office/planning?modaladd=1&fillclient=${userId}`"
                                    class="actionItem ppv2-w-full ppv2-flex ppv2-items-center ppv2-gap-3 ppv2-px-4 ppv2-py-2 ppv2-cursor-pointer ppv2-transition-colors"
                                >
                                    <SquarePen :size="16" />
                                    <span class="poppinsRegular" :style="{ fontSize: normalizeFontSize(14) }">{{
                                        $t('customers.scheduleReservation')
                                    }}</span>
                                </a>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </template>

            <!-- Bulk Actions Slot -->
            <template #bulk-actions="{ selectedCount }">
                <span :style="{ fontSize: normalizeFontSize(15) }" class="poppinsRegular textGray">
                    {{
                        $t('treatment_customer.selectedItems', {
                            count: selectedCount,
                            plural: selectedCount > 1 ? 's' : '',
                        })
                    }}
                </span>
                <span class="poppinsRegular ppv2-text-white ppv2-text-opacity-50" :style="{ fontSize: normalizeFontSize(15) }"
                    >|</span
                >
                <BaseButton
                    variant="outline"
                    @click="cancelSelection"
                    customClass="!ppv2-px-4 !ppv2-h-[30px] !ppv2-flex !ppv2-items-center !ppv2-gap-2"
                >
                    <XCircle :size="14" />
                    <span>{{ $t('treatment_customer.cancelSelection') }}</span>
                </BaseButton>
            </template>
        </DataTable>
    </div>
</template>

<script>
import { SquarePen, Ban, MoreVertical, Download, XCircle, FilePen, ChevronDown } from 'lucide-vue'
import { eventBus } from '../../../Customer/eventBus'
import DataTable from '../../../Shared/DataTable.vue'
import Search from '../../Experience/components/Search.vue'
import BaseCheckbox from '../../../Shared/BaseCheckbox.vue'
import BaseButton from '../../../Shared/BaseButton.vue'
import ExportSelect from '../../../Shared/ExportSelect.vue'
import normalizeSize from '../../../../utils/normalizeSize'
import axios from 'axios'
import normalizeFontSize from '../../../../utils/normalizeFontSize'
import { getPerPage, setPerPage } from '../../../../utils/perPage'

export default {
    name: 'TreatmentCustomerTable',
    components: {
        SquarePen,
        Ban,
        MoreVertical,
        Download,
        XCircle,
        FilePen,
        ChevronDown,
        DataTable,
        Search,
        BaseCheckbox,
        BaseButton,
        ExportSelect,
    },
    props: {
        userId: {
            type: [Number, String],
            default: null,
        },
        exportView: {
            type: Boolean,
            default: true,
        },
        searchView: {
            type: Boolean,
            default: true,
        },
        isDeleted: {
            type: Boolean,
            default: false,
        },
        token: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            search: '',
            statusFilter: '',
            tableData: [],
            itemsPerPage: getPerPage('treatments_customers_items_per_page', 10),
            recordsTotal: 0,
            currentPage: 1,
            loading: false,
            exportLoading: false,
            selectedItems: [],
            selectAll: false,
            sortColumn: 'id',
            sortDirection: 'desc',
            showColumns: false,

            // --- Delete ---
            showDeletePopup: false,
            itemToDelete: null,
            deleteLoading: false,

            // --- Columns ---
            selectedColumnKeys: ['name', 'created_at', 'qte_rest', 'expire_at', 'type', 'actions'],
        }
    },
    computed: {
        allColumns() {
            return [
                {
                    key: 'name',
                    label: this.$t('treatment_customer.treatment_name'),
                    sortable: true,
                    type: 'text',
                },
                {
                    key: 'created_at',
                    label: "Date d'\achat",
                    sortable: true,
                    type: 'text',
                },
                {
                    key: 'qte_rest',
                    label: 'Qte Restante',
                    sortable: true,
                    type: 'text',
                },
                {
                    key: 'expire_at',
                    label: "Date d'expiration",
                    sortable: true,
                    type: 'text',
                },
                {
                    key: 'type',
                    label: 'type',
                    sortable: true,
                    type: 'text',
                },
                { key: 'actions', label: this.$t('common.actions'), sortable: false, type: 'actions' },
            ]
        },
        totalPages() {
            return Math.ceil(this.recordsTotal / this.itemsPerPage)
        },
        visibleColumns() {
            let cols = this.allColumns.filter((column) => this.selectedColumnKeys.includes(column.key))
            if (this.isDeleted) {
                cols = cols.filter((c) => c.key !== 'actions')
            }
            return cols
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
        handlePageChange(page) {
            this.currentPage = page
            this.fetchData()
        },
        handlePerPageChange(perPage) {
            this.itemsPerPage = Number(perPage)
            setPerPage('treatments_customers_items_per_page', this.itemsPerPage)
            this.currentPage = 1
            this.fetchData()
        },
        handleSearchUpdate(searchValue) {
            this.search = searchValue
            this.currentPage = 1
            this.fetchData()
        },
        toggleColumn(key) {
            if (this.selectedColumnKeys.includes(key)) {
                this.selectedColumnKeys = this.selectedColumnKeys.filter((k) => k !== key)
            } else {
                this.selectedColumnKeys.push(key)
            }
            this.fetchData()
        },
        handleStatusChange() {
            this.currentPage = 1
            this.fetchData()
        },
        handleSort(key) {
            if (this.sortColumn === key) {
                this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
            } else {
                this.sortColumn = key
                this.sortDirection = 'asc'
            }
            this.fetchData()
        },
        handleClickOutside(event) {
            if (this.$refs.columnsDropdown && !this.$refs.columnsDropdown.contains(event.target)) {
                this.showColumns = false
            }
        },
        getParams() {
            const params = {
                search: this.search,
                type: this.statusFilter, // 'archived' or ''
                currentPage: this.currentPage,
                itemsPerPage: this.itemsPerPage,
                sortBy: this.sortColumn,
                sortDirection: this.sortDirection,
                userId: this.userId,
            }
            return params
        },
        async fetchData() {
            this.loading = true
            try {
                const params = this.getParams()
                const response = await axios.get('/api/v3/treatment_customer/list', {
                    params,
                    headers: { Authorization: `Bearer ${this.token}` },
                })
                const data = response.data

                this.recordsTotal = data.total
                this.tableData = data.data || []
                this.$emit('total-updated', data.active_count)
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.loading = false
            }
        },

        toggleItemSelection(itemId) {
            const index = this.selectedItems.indexOf(itemId)
            if (index > -1) {
                this.selectedItems.splice(index, 1)
            } else {
                this.selectedItems.push(itemId)
            }
            this.selectAll = this.selectedItems.length === this.tableData.length
        },
        toggleSelectAll() {
            const allIds = this.tableData.map((item) => item.id)
            const allSelected = allIds.length > 0 && allIds.every((id) => this.selectedItems.includes(id))
            if (allSelected) {
                this.selectedItems = []
            } else {
                this.selectedItems = [...allIds]
            }
        },
        async downloadTreatments(format = 'csv') {
            this.exportLoading = true
            try {
                const params = this.getParams()
                params.format = format
                const response = await axios.get('/api/v3/treatment_customer/export', {
                    params,
                    headers: { Authorization: `Bearer ${this.token}` },
                    responseType: 'blob',
                })

                const blob = new Blob([response.data])
                const url = window.URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `treatments_customers-${Date.now()}.${format === 'excel' ? 'xlsx' : 'csv'}`)
                document.body.appendChild(link)
                link.click()
                link.remove()
                window.URL.revokeObjectURL(url)
                this.$toast?.success?.(this.$t('treatment_customer.exportSuccess'))
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.exportLoading = false
            }
        },
        cancelSelection() {
            this.selectedItems = []
            this.selectAll = false
        },
        getTypeColor(type) {
            if (type === 'treatment') {
                return '#FFCDD2'
            } else if (type === 'serie') {
                return '#B2EBF2'
            }
            return '#FFFFFF'
        },
    },
    mounted() {
        this.fetchData()
        eventBus.$on('dt-selected-perpage-changed', this.handlePerPageChange)
        document.addEventListener('click', this.handleClickOutside)
    },
    beforeDestroy() {
        eventBus.$off('dt-selected-perpage-changed', this.handlePerPageChange)
        document.removeEventListener('click', this.handleClickOutside)
    },
    watch: {
        selectedItems: {
            handler(newSelection) {
                const currentPageIds = this.tableData.map((item) => item.id)
                this.selectAll = currentPageIds.length > 0 && currentPageIds.every((id) => newSelection.includes(id))
            },
            deep: true,
        },
        currentPage() {
            this.selectedItems = []
            this.selectAll = false
        },
    },
}
</script>

<style scoped lang="scss">
.menuDropdown {
    background: white;
    color: #94a3b8;
    margin-top: 10px;
    z-index: 50;
    padding: 8px 0;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.dropdownItem:hover {
    background-color: #1a1f37;
    color: white !important;
}

.dropdownItem:hover * {
    color: white !important;
}

.actionsDropdown {
    background: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-radius: 12px;
    padding: 0;
}

.actionItem {
    background: transparent;
    border: none;
    color: #1a1f37;
    text-decoration: none;
    display: flex;
    align-items: center;
}

.actionItem:hover {
    background-color: #f3f4f6;
    color: #1a1f37 !important;
}

.actionItem:hover * {
    color: #1a1f37 !important;
}

.dark {
    .menuDropdown {
        background-color: #2c2c2ce5;
    }

    .actionsDropdown {
        background-color: #2c2c2ce5;
    }

    .actionItem {
        color: #bfbfbf;
    }

    .actionItem:hover {
        background-color: #1a1f37;
        color: white !important;
    }

    .actionItem:hover * {
        color: white !important;
    }
}

.textGray {
    color: #1a1f37;
}

.dark {
    .textGray {
        color: #bfbfbf;
    }
}
</style>
